import { globalCss } from './stitches';

import './preflight.css';

export const useGlobalStyles = globalCss({
  'html, body': {
    height: '100%',
    width: '100%',
    fontSize: '14px',
    overflow: 'hidden',
  },

  body: {
    fontFamily:
      "Inter var, system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, 'Noto Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji'",
    backgroundColor: '$global-bg',
    color: '$global-text',
  },

  '#root': {
    height: '100vh',
    width: '100vw',
    fontSize: '14px',
    overflow: 'hidden',
  },

  /**
   * Webchat specific styles for the Copilot UI.
   */

  '.webchat__bubble *': {
    /**
     * Use the default browser styles for all elements inside the webchat__bubble
     * element so that our reset styles don't interfere with the Copilot formatting.
     */
    all: 'revert',
  },

  '.webchat__bubble code': {
    /**
     * Fix code elements inside the webchat__bubble element not wrapping long lines.
     */
    whiteSpace: 'pre-wrap',
  },
});
